import React, { useEffect, useState } from "react";
import { MESSAGE_TYPE, ATTACHMENT_TYPE } from "../../services/utilityService";
import CallData from "./CallData";
import MediaData from "./MediaData";
import TextData from "./TextData";
import ReferralData from "./ReferralData";
import PrescriptionData from "./PrescriptionData";
import { ENDPOINTS } from "../../services/ApiService";
import { MODALS } from "../utils/ConsultationModals";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { updatePrescriptionDetail } from "../../actions/consultation";
import { isFeatureEnabled } from "@reliance/feature-flags";
import { features } from "../../services/constants";

const BubbleLeft = (props) => {
  const [prescriptions, setPresctiption] = useState(null);
  const getPrescriptionDetails = async () => {
    if (
      props.type === MESSAGE_TYPE.action &&
      props.attachments.length > 0 &&
      props.attachments[0].type === ATTACHMENT_TYPE.prescription &&
      props.attachments.length
    ) {
      if (props.state === "active") {
        try {
          const data = await props.service.get(
            ENDPOINTS.consultations.prescriptions(
              props.consultationId,
              props.attachments[0].content.id
            )
          );
          setPresctiption(data?.data);
          props.dispatch(
            updatePrescriptionDetail({
              ...data?.data,
              message: props.message,
              prescriptionMessage: props.prescriptionMessage,
            })
          );
        } catch (error) {
          console.info(error); // handle get prescription error
        }
      }
    }
  };

  useEffect(() => {
    if (
      props.type === MESSAGE_TYPE.action &&
      props.attachments.length > 0 &&
      props.attachments[0].type === ATTACHMENT_TYPE.prescription &&
      props.attachments.length
    ) {
      getPrescriptionDetails();
      props.dispatch(updatePrescriptionDetail(prescriptions));
    }
  }, [props.attachments.length]);

  return (
    <React.Fragment>
      <div className="doctor-chat">
        {props.type ? (
          props.type === MESSAGE_TYPE.action &&
          props.attachments?.length &&
          props.attachments[0].type === ATTACHMENT_TYPE.prescription ? null : (
            <div className="chat-item__message doctor-chat__bubble">
              {displayMessageByType({ ...props, prescriptions }, props.type)}
            </div>
          )
        ) : (
          <div className="chat-item__message doctor-chat__bubble">
            <TextData {...props} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const displayMessageByType = (props, type) => {
  const showFufillmentModal = () => {
    props.togglePharmacyModal(MODALS.consultationFulfillment);
  };

  if (type === MESSAGE_TYPE.text) {
    return <TextData {...props} />;
  }

  if (type === MESSAGE_TYPE.call) {
    return <CallData {...props} />;
  }

  if (type === MESSAGE_TYPE.action) {
    // Handle case with no attachments
    if (!props.attachments.length) {
      return <TextData {...props} />;
    }

    // Media attachment handling
    if (props.attachments[0].type === ATTACHMENT_TYPE.media) {
      return <MediaData {...props} />;
    }

    // Prescription handling - removed block statement and fixed conditional logic
    if (
      props.attachments[0].type === ATTACHMENT_TYPE.prescription &&
      props.state !== "deleted" &&
      !isFeatureEnabled(features.telemedicineAbuseBanner)
    ) {
      return (
        <PrescriptionData
          {...props}
          showFufillmentModal={showFufillmentModal}
        />
      );
    }

    // Referral handling
    if (props.attachments[0].type === ATTACHMENT_TYPE.referral) {
      return <ReferralData {...props} />;
    }

    // Default case if none of the above conditions are met
    return <TextData {...props} />;
  }

  // Default return if no matching type
  return <TextData {...props} />;
};

const mapStateToProps = (store) => {
  const { consultation } = store;
  return {};
};

export default withRouter(connect(mapStateToProps)(BubbleLeft));
